import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { AppText } from '@/components/ui/AppText';
import { useThemePalette } from '@/config/theme';

/**
 * Small "Out / خرج" pill marking a nation eliminated from the World Cup. Shared
 * across every WC surface (album, fantasy, groups, golden boot, bracket) so the
 * elimination treatment is consistent. `compact` drops the label to icon-only.
 */
export function OutBadge({ compact = false }: { compact?: boolean }) {
  const palette = useThemePalette();
  const { t } = useTranslation();
  return (
    <View
      className="flex-row items-center gap-1 self-start rounded-full px-1.5 py-0.5"
      style={{
        backgroundColor: `${palette.loss}22`,
        borderWidth: 1,
        borderColor: `${palette.loss}55`,
      }}
    >
      <Ionicons name="close-circle" size={compact ? 11 : 12} color={palette.loss} />
      {!compact ? (
        <AppText variant="micro" weight="bold" style={{ color: palette.loss }}>
          {t('wc.out')}
        </AppText>
      ) : null}
    </View>
  );
}
